module.exports = __webpack_public_path__ + "static/media/loader.ba23f10b.gif";